import create from "zustand";
import storage from "../util/storage";

const manager_info = {};

export const useManagerStore = create((set) => ({
    manager: {},
    loginCheck: (_manager_info) =>
        set((state) => {
            return { manager: { ...manager_info, ..._manager_info } };
        }),
    login: (manager_info, id, pwd) =>
        set((state) => {
            storage.setToken(manager_info.token);
            return { manager: { ...manager_info } };
        }),
    setManagerInfo: (manager_info) =>
        set((state) => {
            return { manager: { ...manager_info } };
        }),
    logout: () =>
        set((state) => {
            storage.clearToken();
            return { manager: {} };
        }),
}));
